import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { useConfirm } from '../context/ConfirmContext';

const STARS = (n) => '★'.repeat(n) + '☆'.repeat(5 - n);

const TRADE_GROUPS = ['plumber', 'electrician', 'hvac', 'carpenter', 'painter', 'roofer', 'landscaper', 'general', 'other'];

const Contacts = () => {
  const { contacts, fetchContacts, removeContact, loading } = useApp();
  const { confirm } = useConfirm();

  useEffect(() => { fetchContacts(); }, [fetchContacts]);

  const handleDelete = async (c) => {
    if (await confirm({ title: 'Delete contact', message: `"${c.name}" will be permanently removed.` })) {
      removeContact(c._id).catch(() => {});
    }
  };

  const byTrade = contacts.reduce((acc, c) => {
    if (!acc[c.trade]) acc[c.trade] = [];
    acc[c.trade].push(c);
    return acc;
  }, {});

  if (loading) return <div className="loading">Loading…</div>;

  return (
    <div className="page">
      <div className="page-header">
        <h1>Contacts</h1>
        <Link to="/contacts/new" className="btn btn-primary">+ Add Contact</Link>
      </div>

      {contacts.length === 0 ? (
        <p className="empty-state">No contacts yet. <Link to="/contacts/new">Add your first contact.</Link></p>
      ) : (
        TRADE_GROUPS.filter((t) => byTrade[t]).map((trade) => (
          <section key={trade}>
            <h2 style={{ textTransform: 'capitalize' }}>{trade}</h2>
            <div className="card-grid">
              {byTrade[trade].map((c) => (
                <div key={c._id} className="card">
                  <div className="card-header">
                    <h3 className="card-title">{c.name}</h3>
                    {c.rating && <span className="contact-stars">{STARS(c.rating)}</span>}
                  </div>
                  <div className="card-body">
                    {c.company && <p className="card-detail">{c.company}</p>}
                    {c.phone && <p className="card-detail"><a href={`tel:${c.phone}`}>{c.phone}</a></p>}
                    {c.email && <p className="card-detail"><a href={`mailto:${c.email}`}>{c.email}</a></p>}
                    {c.notes && <p className="card-detail contact-notes">{c.notes}</p>}
                  </div>
                  <div className="card-actions">
                    <Link to={`/contacts/${c._id}/edit`} className="btn btn-secondary btn-sm">Edit</Link>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(c)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))
      )}
    </div>
  );
};

export default Contacts;
